<div class="terminals-import-row-details-view-container" *ngIf="terminalsImportRowObject" fxLayout="column" fxLayoutGap="15px" >
  <div class="id-info" >
    <mat-form-field appearance="fill" color="accent">
      <mat-label>ID</mat-label>
      <input matInput placeholder="ID" [disabled]="true" [value]="terminalsImportRowObject.id?.toString()">
    </mat-form-field>
  </div>

  <div class="status-info">
    <mat-form-field appearance="fill" [ngClass]="'input-color-' + terminalsImportRowObject.status.color">
      <mat-label>Status</mat-label>
      <input matInput placeholder="Status" [disabled]="true" [value]="terminalsImportRowObject.status?.name">
    </mat-form-field>
  </div>

    <div fxLayout="row" fxLayoutGap="15px">
      <button
        *ngIf=" (userPermissions | async)?.terminals.write && terminalsImportRowObject.status.key === TERMINALS_IMPORT_ROW_STATUS_FOR_VERIFICATION  && !(userPermissions | async)?.terminals.admin_root"
        [disabled]="!(userPermissions | async).terminals.write"
        mat-stroked-button (click)="partnerFacilityChange()" color="primary"
      ><mat-icon>edit</mat-icon><span>Zmiana placówki</span></button>
      <button
        *ngIf=" (userPermissions | async)?.terminals.admin_root"
        [disabled]="!(userPermissions | async).terminals.admin_root"
        mat-stroked-button (click)="partnerFacilityChange()" color="primary"
      ><mat-icon>edit</mat-icon><span>Zmiana placówki</span></button>

      <button
        *ngIf=" (userPermissions | async)?.terminals.delete && terminalsImportRowObject.status.key === TERMINALS_IMPORT_ROW_STATUS_UNSETTLED "
        [disabled]="!(userPermissions | async).terminals.delete"
        mat-stroked-button (click)="statusChange()" color="primary"
      ><span>Rozliczona</span></button>
      <button
        mat-stroked-button
        [style.visibility]="'hidden'"
      ><span>Do weryfikacji</span></button>
    </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Dane </h3>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Tytuł płatności" [value]="terminalsImportRowObject?.paymentTitle"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Numer karty płatniczej" [value]="terminalsImportRowObject?.cardNumber"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Kwota" >
                  {{(terminalsImportRowObject.transferAmount === null ? 0 : terminalsImportRowObject.transferAmount) | number:'1.2-2'}} zł
                </app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Data" [value]="terminalsImportRowObject?.transactionAt| date:'y-MM-dd'"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Adres placówki z pliku" [value]="terminalsImportRowObject?.facilityAddress"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="terminalsImportRowObject.note">
              <div fxFlex="100">
                <app-detail header="Powód zmiany statusu transakcji" [value]="terminalsImportRowObject.note "></app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

    </div>

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Struktura</h3>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Numer terminala" [value]="terminalsImportRowObject?.terminalNumber"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px" *ngFor="let partner of terminalsImportRowObject.partnerFacility?.partners">
              <div fxFlex="100">
                <app-detail header="Partner" [value]="partner.fullName"  [link]="partner ? ['/partnerzy/szczegoly', partner.uuid] : undefined"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Placówka" [value]="terminalsImportRowObject.partnerFacility?.address.searchString"></app-detail>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
    </div>


  </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">
    <div fxFlex="100">
      <mat-card class="partners-add-card">
        <div fxLayout="row">
          <h3>Polisy</h3>
        </div>
        <div fxLayout="column" fxLayoutGap="15px"  *ngFor="let terminal of terminalsImportRowObject.terminals">
          <div fxLayout="row" fxLayoutGap="15px">
            <div fxFlex="25">
              <app-detail header="TU" [value]="terminal.insuranceCompany?.name" ></app-detail>
            </div>

            <div fxFlex="25">
              <app-detail header="Numer polisy" [value]="terminal.policyNumber" [link]="['terminale/polisy/szczegoly', terminal.uuid]"></app-detail>
            </div>

            <div fxFlex="25">
              <app-detail header="Numer rachunku bankowego" [value]="terminal.accountNumber"></app-detail>
            </div>

            <div fxFlex="25">
              <app-detail header="Kwota"[value]="">{{(terminal.sum === null ? 0 : terminal.sum) | number:'1.2-2'}} zł</app-detail>
            </div>
          </div>
        </div>

      </mat-card>
    </div>

  </div>

</div>
